export default class RemoveItem extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.removeEvent = new Event("remove", { bubbles: true });

    this.button.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    this.button.dispatchEvent(this.removeEvent);
  }
}
